import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const upload = async (params) => {
  try {
    let bodyParams = reqTransform.upload(params);
    const formData = new FormData();

    formData.append('advertisement_banner_id', bodyParams.advertisement_banner_id);
    formData.append('banner_name', bodyParams.banner_name);
    formData.append('banner_type_enum', bodyParams.banner_type_enum);
    formData.append('invoking_person_id', bodyParams.invoking_person_id);
    formData.append('operation_enum', bodyParams.operation_enum);
    formData.append('tagged_company_id', bodyParams.tagged_company_id);
    formData.append('tagged_person_id', bodyParams.tagged_person_id);
    formData.append('redirection_url', bodyParams.redirection_url);

    formData.append('banner_pic_url', bodyParams.banner_pic_url);

    const url = `${baseUrl}/BioFuelCommonUtilities/api/Banner/UpdateAndUploadBanner`;
    const res = await utils.fetch(
      url,
      {
        method: 'POST',
        body: formData,
      },
      false,
    ).ready;

    const resData = await utils.processApiRes(res);
    return resTransform.upload(resData);
  } catch (err) {
    const errors = await utils.processApiErrors(err, '', 'UpdateAndUploadBanner');
    throw errors;
  }
};

export const fetchList = async (params) => {
  try {
    const qs = reqTransform.fetchList(params);
    const url = `${baseUrl}/BioFuelCommonUtilities/api/Banner/FetchAllBanners?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchList(resData);
  } catch (err) {
    console.log('FetchUploadList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchAllBanners');
    throw errors;
  }
};
